import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      nav: { home: "Home", events: "Events", connect: "Stay connected" },
      home: {
        eyebrow: "Food. Clothing. Community.",
        title: "A practical hand and a hopeful next step.",
        body: "Hope Hangar connects neighbors with food distributions, clothing, community events, and the information families need to participate.",
        connect: "Stay connected",
        events: "View upcoming events",
        how: "How it works",
        step1: "Share how we can reach you",
        step2: "Receive distribution and event updates",
        step3: "Register your household when planning is needed",
      },
      common: {
        required: "Required",
        submit: "Submit",
        sending: "Sending…",
        back: "Back",
        language: "Language",
        footerTagline: "Food, clothing, and community care.",
      },
      form: {
        loading: "Loading form…",
        error: "We could not load this form.",
        contact: "At least a phone number or email address is required.",
      },
      events: {
        title: "Upcoming events",
        intro: "Register your household so our teams can prepare well.",
        register: "Register",
        empty: "No events are currently open for registration.",
        party: "How many people are attending?",
        success: "Your household is registered.",
        returningTitle: "Attended before? Save time.",
        returningBody:
          "Verify your email or mobile number to securely fill in your contact details.",
        email: "Email",
        sms: "Text",
        emailPlaceholder: "you@example.com",
        smsPlaceholder: "Mobile phone",
        sendCode: "Send code",
        code: "Verification code",
        codePlaceholder: "6-digit code",
        verifyCode: "Verify and fill details",
        profileLoaded: "Verified. Your contact details are filled in below.",
        lookupError: "We could not verify your profile.",
      },
    },
  },
  es: {
    translation: {
      nav: { home: "Inicio", events: "Eventos", connect: "Mantente conectado" },
      home: {
        eyebrow: "Alimentos. Ropa. Comunidad.",
        title: "Ayuda práctica y un próximo paso lleno de esperanza.",
        body: "Hope Hangar conecta a nuestros vecinos con distribuciones de alimentos, ropa, eventos comunitarios y la información que las familias necesitan para participar.",
        connect: "Mantente conectado",
        events: "Ver próximos eventos",
        how: "Cómo funciona",
        step1: "Comparte cómo podemos comunicarnos contigo",
        step2: "Recibe noticias sobre distribuciones y eventos",
        step3: "Registra a tu hogar cuando necesitemos planificar",
      },
      common: {
        required: "Obligatorio",
        submit: "Enviar",
        sending: "Enviando…",
        back: "Atrás",
        language: "Idioma",
        footerTagline: "Alimentos, ropa y cuidado comunitario.",
      },
      form: {
        loading: "Cargando formulario…",
        error: "No pudimos cargar este formulario.",
        contact: "Se requiere un número de teléfono o correo electrónico.",
      },
      events: {
        title: "Próximos eventos",
        intro:
          "Registra a tu hogar para que nuestros equipos puedan prepararse bien.",
        register: "Registrarse",
        empty: "Actualmente no hay eventos abiertos para registro.",
        party: "¿Cuántas personas asistirán?",
        success: "Tu hogar está registrado.",
        returningTitle: "¿Ya asististe? Ahorra tiempo.",
        returningBody:
          "Verifica tu correo electrónico o teléfono para completar tus datos de contacto de forma segura.",
        email: "Correo",
        sms: "Texto",
        emailPlaceholder: "tu@ejemplo.com",
        smsPlaceholder: "Teléfono móvil",
        sendCode: "Enviar código",
        code: "Código de verificación",
        codePlaceholder: "Código de 6 dígitos",
        verifyCode: "Verificar y completar",
        profileLoaded:
          "Verificado. Tus datos de contacto aparecen a continuación.",
        lookupError: "No pudimos verificar tu perfil.",
      },
    },
  },
};

void i18n.use(initReactI18next).init({
  resources,
  lng:
    localStorage.getItem("hopehangar-locale") ||
    (navigator.language.startsWith("es") ? "es" : "en"),
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
